var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMarker(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 11.8 24.7",
    style: {
      enableBackground: "new 0 0 11.8 24.7"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M5.7,15.1L5.7,15.1C5.6,15,4.3,13.5,3,11.6c-0.7-1-1.3-2-1.8-3.1c-0.5-1.1-0.8-2.1-0.8-3c0-2.9,2.5-5.3,5.5-5.3 c3,0,5.5,2.4,5.5,5.3c0,0.9-0.3,1.9-0.8,3c-0.5,1.1-1.1,2.1-1.8,3.1c-1.3,1.9-2.7,3.4-2.8,3.5l0,0C6,15.2,5.8,15.2,5.7,15.1z  M2.7,5.6c0,1.7,1.5,3.1,3.2,3.1c1.8,0,3.2-1.4,3.2-3.1c0-1.7-1.5-3.1-3.2-3.1S2.7,3.9,2.7,5.6z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M8.2,22.1c0,1.2-1,2.2-2.3,2.2c-1.3,0-2.3-1-2.3-2.2c0-1.2,1-2.2,2.3-2.2C7.2,20,8.2,20.9,8.2,22.1z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarker);
export default __webpack_public_path__ + "static/media/marker.8658c1faadf05a91924a26b6d5a5bf0f.svg";
export { ForwardRef as ReactComponent };